import React, { useEffect } from 'react'
import { Provider, useDispatch } from 'react-redux'
import RequestInfo from './components/RequestInfo'
import { getFormInstance } from './slices/formInstanceSlice'
import { initialInfoGlobal } from './slices/globalSlice'
import { initialInfoPrice } from './slices/priceSlice'
import { sortAttachments } from './utils'
import store from './store'
import ProcessorForm from './components/ProcessorForm'
import ProcessInterstitial from './components/ProcessInterstitial'

function AutoQuestionnaireProcessing(props) {
  const {
    possible_prices,
    preset_price,
    auto_pricing,
    auto_archive,
    building_url,
    building_address,
    building_type,
    questionnaire_request,
    form_title,
    attachments,
    questionnaire_form_url,
    questionnaire_form_pages,
    workflow,
  } = props
  const dispatch = useDispatch()

  useEffect(() => {
    if (workflow.workflow_type === 'automated' && workflow.workflow_attributes.form_instance_id) {
      dispatch(getFormInstance(workflow.workflow_attributes.form_instance_id))
    }

    dispatch(
      initialInfoPrice({
        autoPricing: auto_pricing,
        possiblePrices: possible_prices,
        presetPrice: preset_price,
        needsPayment: questionnaire_request.needs_payment,
        total: questionnaire_request.price,
      })
    )
    dispatch(
      initialInfoGlobal({
        id: questionnaire_request.id,
        comment: questionnaire_request.comment,
        hashedId: questionnaire_request.hashed_id,
        purchaserToken: questionnaire_request.purchaser_token,
        confirmationId: questionnaire_request.confirmation_id,
        propertyManagerId: questionnaire_request.property_manager_id,
        requesterInfo: {
          name: questionnaire_request.buyer_name,
          company: questionnaire_request.company_name,
          email: questionnaire_request.buyer_email,
          phoneNumber: questionnaire_request.buyer_phone,
        },
        propertyAddress: { address: questionnaire_request.property_address, unit: questionnaire_request.unit_id },
        buildingUrl: building_url,
        buildingId: questionnaire_request.building_id,
        buildingAddress: building_address,
        buildingType: building_type,
        statuses: questionnaire_request.statuses,
        currentStatus: questionnaire_request.current_status,
        respondingFiles: sortAttachments(Object.values(attachments)),
        questionnaireFormUrl: questionnaire_form_url,
        questionnaireFormPages: questionnaire_form_pages,
        workflow: questionnaire_request.workflow,
        paidAt: questionnaire_request.paid_at,
        autoArchive: auto_archive,
      })
    )
  }, [possible_prices, preset_price, auto_pricing, auto_archive, building_address, questionnaire_request, attachments, workflow])

  return (
    <div className="auto-questionnaire-processing-page-body">
      <div className="processing-page-form-container">
        <ProcessorForm formTitle={form_title} />
        <ProcessInterstitial initialAttachments={attachments} />
      </div>
      <div className="processing-page-request-info">
        <RequestInfo initialAttachments={attachments} />
      </div>
    </div>
  )
}

export default function AutoQuestionnaireProcessingProvider(props) {
  return (
    <Provider store={store}>
      <AutoQuestionnaireProcessing {...props} />
    </Provider>
  )
}
